import { FC, HTMLAttributes, MouseEvent } from 'react';
import cn from 'classnames';

import Arrow from '@Components/Arrow';
import styles from './NavSideArrows.module.css';

export interface NavSideArrowsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  onPrev?: (e: MouseEvent) => void;
  onNext?: (e: MouseEvent) => void;
  view?: 'circle-chevron' | 'chevron';
  inversed?: boolean;
}

const NavSideArrows: FC<NavSideArrowsProps> = (props) => {
  const { className, view, inversed, onPrev, onNext, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.arrows, className)}>
      <Arrow
        position='left'
        view={view}
        inversed={inversed}
        className={styles.prev}
        onClick={onPrev}
      />

      <Arrow
        position='right'
        view={view}
        inversed={inversed}
        className={styles.next}
        onClick={onNext}
      />
    </div>
  );
};

export default NavSideArrows;
